import actionTypes from './actionTypes'
import sessionTypes from 'helpers/enums/sessionTypes'

const myLibraryActions = {

	lessonsFetched(lessonsData, isFullPage, libraryType) {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_FETCHED,
			lessonsData,
			isFullPage,
			libraryType,
		}
	},

	lessonsFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_FAILED,
			serverError,
		}
	},

	foldersFetched(foldersData) {
		return {
			type: actionTypes.MY_LIBRARY_FOLDERS_FETCHED,
			foldersData,
		}
	},

	openSettingsCollaborateDisabled(doNotShowAgain) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_OPEN_SETTINGS,
			doNotShowAgain,
		}
	},

	launchHomeworkWithCollaborateDisabled(presentation_uid, doNotShowAgain, isNew) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_LAUNCH,
			presentation_uid,
			doNotShowAgain,
			isNew,
		}
	},

	launchHomework(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK,
			presentation_uid,
		}
	},

	launchLiveLesson(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_LIVE_LESSON,
			presentation_uid,
		}
	},

	launchFrontOfTheClassroom(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_FRONT_OF_THE_CLASSROOM,
			presentation_uid,
		}
	},

	launchVideoPreview(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_VIDEO_PREVIEW,
			presentation_uid,
		}
	},

	launchFrontOfTheClassroomPreview(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM,
			presentation_uid,
		}
	},

	launchAllDevicesPreview(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_LAUNCH_ALL_DEVICES,
			presentation_uid,
		}
	},

	launchStudentPacedPreview(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED,
			presentation_uid,
		}
	},

	myLibrarySessionLTICanvasSaved(payload, presentationUid, sessionType, teams) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED,
			payload,
			presentationUid,
			sessionType,
			teams,
		}
	},

	myLibraryHomeworkFetched(payload, presentationUid, isNew) {
		return {
			type: actionTypes.MY_LIBRARY_HOMEWORK_FETCHED,
			payload,
			presentationUid,
			isNew,
		}
	},

	myLibraryHomeworkFailed(error, presentationUid, isNew) {
		return {
			type: actionTypes.MY_LIBRARY_HOMEWORK_FAILED,
			error,
			presentationUid,
			isNew,
		}
	},

	myLibraryLiveSessionFailed(error, presentationUid) {
		return {
			type: actionTypes.MY_LIBRARY_LIVE_SESSION_FAILED,
			error,
			presentationUid,
		}
	},

	myLibraryLTISessionFailed(error, presentationUid) {
		return {
			type: actionTypes.MY_LIBRARY_LTI_SESSION_FAILED,
			error,
			presentationUid,
		}
	},

	myLibrarySessionFetched(payload, presentation_uid, isNew, hasZoom) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_FETCHED,
			payload,
			presentation_uid,
			isNew,
			hasZoom,
		}
	},

	myLibraryExtensionSessionFetched(presentation_uid, classroomData, lessonMode, isTutorial) {
		return {
			type: actionTypes.MY_LIBRARY_EXTENSION_SESSION_FETCHED,
			presentation_uid,
			classroomData,
			lessonMode,
			isTutorial,
		}
	},

	myLibraryExtensionPremiumFeatureUpgrade(payload) {
		return {
			type: actionTypes.MY_LIBRARY_EXTENSION_PREMIUM_FEATURE_UPGRADE,
			payload,
		}
	},

	myLibraryExtensionSessionFailed(error) {
		return {
			type: actionTypes.MY_LIBRARY_EXTENSION_SESSION_FAILED,
			error,
		}
	},

	extensionLessonLaunchedSuccess(classroomData) {
		return {
			type: actionTypes.MY_LIBRARY_EXTENSION_LESSON_LAUNCHED_SUCCESS,
			classroomData,
		}
	},

	resumeActiveSession(presentation_uid, session_uid, sessionType = sessionTypes.LIVE_SESSION, hasZoom = false) {
		return {
			type: actionTypes.MY_LIBRARY_RESUME_ACTIVE_LIVE_SESSION,
			presentation_uid,
			session_uid,
			sessionType,
			hasZoom,
		}
	},

	shareActiveStudentPacedSession(sessionData, presentationUid) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_ACTIVE_STUDENT_PACED_SESSION,
			sessionData,
			presentationUid,
		}
	},

	closeStudenPacedCodesModal() {
		return {
			type: actionTypes.MY_LIBRARY_STUDENT_PACED_CODES_CLOSED,
		}
	},

	launchNewHomework(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_NEW_HOMEWORK,
			presentation_uid,
		}
	},

	launchNewSession(presentation_uid, hasZoom = false) {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_NEW_LIVE_SESSION,
			presentation_uid,
			hasZoom,
		}
	},

	cancelSessionLaunch() {
		return {
			type: actionTypes.MY_LIBRARY_CANCEL_SESSION_LAUNCH,
		}
	},

	getLessonsNextPage() {
		return {
			type: actionTypes.MY_LIBRARY_GET_LESSONS_NEXT_PAGE,
		}
	},

	closeLiveSessionCodesModal() {
		return {
			type: actionTypes.MY_LIBRARY_LIVE_SESSION_CODES_CLOSED,
			session_uid: '',
		}
	},

	openSessionCodeModal() {
		return {
			type: actionTypes.MY_LIBRARY_HAS_MULTIPLE_LIVE_SESSIONS,
		}
	},

	saveChanges(entity) {
		return {
			type: actionTypes.MY_LIBRARY_SAVE_CHANGES,
			entity,
		}
	},

	saveChangesFetched(saveResponse, entity) {
		return {
			type: actionTypes.MY_LIBRARY_SAVE_CHANGES_FETCHED,
			saveResponse,
			entity,
		}
	},

	saveChangesFailed(error, entity) {
		return {
			type: actionTypes.MY_LIBRARY_SAVE_CHANGES_FAILED,
			error,
			entity,
		}
	},

	closeSaveChangesModal() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_SAVE_CHANGES_MODAL,
		}
	},

	closeSaveConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_SAVE_CONFIRM,
		}
	},

	pendingLessonsStatusFetched(pending_lessons) {
		return {
			type: actionTypes.MY_LIBRARY_PENDING_LESSONS_STATUS_FETCHED,
			pending_lessons,
		}
	},

	previewLesson(lessonId) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_LESSON,
			lessonId,
		}
	},

	deleteLesson(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_LESSON,
			lesson,
		}
	},

	deleteLessonConfirmed(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_LESSON_CONFIRMED,
			lesson,
		}
	},

	deleteLessonFailed(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_LESSON_FAILED,
			lesson,
		}
	},

	deleteLessonSuccess(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_LESSON_SUCCESS,
			lesson,
		}
	},

	myLibraryDuplicateLessonFailed(payload, upgradeSource) {
		return {
			type: actionTypes.MY_LIBRARY_DUPLICATE_LESSON_FAILED,
			payload,
			upgradeSource,
		}
	},

	cancelDeleteLesson(lessonId) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_LESSON_CANCELLED,
			lessonId,
		}
	},

	gotoReports(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_GO_TO_REPORTS,
			id: lesson.data.id,
		}
	},

	addToPublicLibrary(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY,
			lesson,
		}
	},

	addToPublicLibrarySuccess(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY_SUCCESS,
			lesson,
			library_type: 'public',
		}
	},

	addToPublicLibraryFailed(response, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY_FAILED,
			lesson,
			response,
		}
	},

	addToFolder(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER,
			lesson,
		}
	},

	removeFromFolder(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER,
			lesson,
		}
	},

	removeFromFolderConfirmed(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CONFIRMED,
			lesson,
		}
	},

	removeFromFolderCancelled() {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CANCELLED,

		}
	},

	removeFromFolderSuccess(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_SUCCESS,
			lesson,
			method: 'Ellipses',

		}
	},

	removeFromFolderFailed(error, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_FAILED,
			error,
			lesson,

		}
	},

	addToFolderCancel(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_CANCELLED,
			lesson,
		}
	},

	addToFolderFailed(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_FAILED,
			lesson,
		}
	},

	addToFolderSelected(lesson, folderUID) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_SELECTED,
			lesson,
			folderUID,
		}
	},

	addToFolderSuccess(folder) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_SUCCESS,
			folder,
			method: 'Ellipses',
		}
	},

	addToNewFolderSelected(lesson, folder) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_NEW_FOLDER,
			lesson,
			folder: folder || 0,
		}
	},

	addOrUpdateFolder(folder, folder_name, lesson, parentFolder) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER,
			folder,
			folder_name,
			lesson,
			parentFolder,
		}
	},

	addOrUpdateFolderSuccess(response, action) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_SUCCESS,
			folder: action.folder,
			lesson: action.lesson,
			response,
			foldersData: response.payload,
			folderUID: response.payload.entityUID,
			parents: response.payload.parents.length,
		}
	},

	addOrUpdateFolderFailed(error) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_FAILED,
			error }
	},

	cancelAddOrUpdateFolder(folder, folder_name, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_CANCELLED,
			folder,
			folder_name,
			lesson,
		}
	},

	changeFolderColor(colorId) {
		return {
			type: actionTypes.MY_LIBRARY_CHANGE_FOLDER_COLOR,
			colorId,
		}
	},

	changeFolderColorSuccess(payload) {
		return {
			type: actionTypes.MY_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS,
			foldersData: payload,
		}
	},

	changeFolderColorError(error) {
		return {
			type: actionTypes.MY_LIBRARY_CHANGE_FOLDER_COLOR_ERROR,
			error,
		}
	},

	exportToPDF(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_EXPORT_TO_PDF,
			lesson,
		}
	},

	closeExportToPDFConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_EXPORT_TO_PDF_CONFIRM,
		}
	},

	exportToGoogleDrive(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_EXPORT_TO_GOOGLE_DRIVE,
			lessonid: lesson.data.id,
		}
	},

	exportToLocalDrive(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE,
			lesson,
		}
	},

	exportToLocalDriveFetched(pdfUrl) {
		return {
			type: actionTypes.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE_FETCHED,
			pdfUrl,
		}
	},

	addToPrivateLibrary(library_type, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY,
			library_type,
			lesson,
			folderId: -1,
		}
	},

	addToPrivateLibrarySuccess(library_type, library_uid, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS,
			library_type,
			library_uid,
			lesson,
		}
	},

	addToPrivateLibraryStarted() {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_STARTED,
		}
	},

	addToPrivateLibraryFailed(error, library_type, lesson) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED,
			error,
			library_type,
			lesson,
		}
	},

	closeSaveLessonNotification() {
		return {
			type: actionTypes.MY_LIBRARY_SAVE_LESSON_NOTIFICATION_CLOSE,
		}
	},

	closeAddedLessonToPrivateLibrary() {
		return {
			type: actionTypes.MY_LIBRARY_ADDED_LESSON_TO_PRIVATE_LIBRARY_CLOSE,
		}
	},

	visitPrivateLibrary(library_uid) {
		return {
			type: actionTypes.MY_LIBRARY_VISIT_PRIVATE_LIBRARY,
			library_uid,
		}
	},

	renameFolder(folder, name) {
		return {
			type: actionTypes.MY_LIBRARY_FOLDER_RENAME,
			folder,
			name,
		}
	},

	addFolder() {
		return {
			type: actionTypes.MY_LIBRARY_ADD_FOLDER,
		}
	},

	removeFolder(folder) {
		return {
			type: actionTypes.MY_LIBRARY_REMOVE_FOLDER,
			folder,
		}
	},

	closeRemoveFolderConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_REMOVE_FOLDER_CONFIRM,
		}
	},

	deleteFolderConfirmed(folder) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_FOLDER_CONFIRMED,
			folder,
		}
	},

	deleteFolderResponseSuccess(payload, folderName) {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_FOLDER_RESPONSE_SUCCESS,
			foldersData: payload,
			folderUID: payload.parentId,
			folderName,
		}
	},

	deleteFolderResponseFailed() {
		return {
			type: actionTypes.MY_LIBRARY_DELETE_FOLDER_RESPONSE_FAILED,
		}
	},

	editLesson(entity) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_LESSON,
			lessonData: entity,
		}
	},

	editGoogleSlidesInNearpod(entity) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_GOOGLE_SLIDES_IN_NEARPOD,
			lessonData: entity,
		}
	},

	closeEditStoreLessonConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_EDIT_STORE_LESSON_CONFIRM,
		}
	},

	editStoreLesson(lessonData) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_STORE_LESSON,
			lessonData,
		}
	},

	duplicateLesson(lesson) {
		return {
			type: actionTypes.MY_LIBRARY_DUPLICATE_LESSON,
			lessonData: lesson.data,
		}
	},

	duplicateLessonConfirmed(lessonData) {
		return {
			type: actionTypes.MY_LIBRARY_DUPLICATE_LESSON_CONFIRMED,
			lessonData,
		}
	},

	duplicateLessonConfirmDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_DUPLICATE_LESSON_CONFIRM_DISMISS,
		}
	},

	closeEditRunningLessonConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_EDIT_RUNNING_LESSON_CONFIRM,
		}
	},

	closeEditLessonInPublicLibraryConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM,
		}
	},

	editLessonInPublicLibrary(lessonData) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY,
			lessonData,
		}
	},

	editRunningLesson(lessonData) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_RUNNING_LESSON,
			lessonData,
		}
	},

	editLessonSuccess(redirectUrl) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_LESSON_SUCCESS,
			redirectUrl,
		}
	},

	editLessonFailed(payload, upgradeSource, lessonData) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_LESSON_FAILED,
			payload,
			upgradeSource,
			lessonData,
		}
	},

	duplicateLessonSuccess(redirectUrl) {
		return {
			type: actionTypes.MY_LIBRARY_DUPLICATE_LESSON_SUCCESS,
			redirectUrl,
		}
	},

	addMultipleLessonsToFolder(folder) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER,
			folder,
		}
	},

	addMultipleLessonsToFolderCancel() {
		return {
			type: actionTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER_CANCELLED,
		}
	},

	lessonsPickerSearchLessons() {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS,
		}
	},

	lessonsPickerSearchLessonsFetched(payload) {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS_FETCHED,
			payload,
		}
	},

	lessonsPickerInit() {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_PICKER_INIT,
		}
	},

	lessonsPickerSaveLessons() {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS,
		}
	},

	lessonsPickerSaveLessonsSuccess(folderUID) {
		return {
			type: actionTypes.MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS_SUCCESS,
			folderUID,
			method: 'Breadcrumb',
		}
	},

	previewDataFetched(response) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_DATA_FETCHED,
			response,
		}
	},

	previewDataFetchedFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_DATA_FETCHED_FAILED,
			serverError,
		}
	},

	homeworkUpgradeSelected(sessionData, button, isIframeView) {
		return {
			type: actionTypes.MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED,
			sessionData,
			button,
			isIframeView,
		}
	},
	editLessonInit(lessonData, isGoogleSlidesEdit = false) {
		return {
			type: actionTypes.MY_LIBRARY_EDIT_LESSON_INIT,
			lessonData,
			isGoogleSlidesEdit,
		}
	},
	lessonDataSaved(entity) {
		return {
			type: actionTypes.MY_LIBRARY_LESSON_DATA_SAVED,
			entity,
		}
	},

	createLesson() {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_LESSON,
		}
	},

	createLessonThumbnail() {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_LESSON_THUMBNAIL,
		}
	},

	createGoogleDriveLesson() {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON,
		}
	},

	createGoogleDriveLessonFailed(error) {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_FAILED,
			error,
		}
	},

	createGoogleDriveLessonSuccess(lessonData, isInIframe) {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_SUCCESS,
			lessonData,
			isInIframe,
		}
	},

	shareLesson(entityUID) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_LESSON,
			entityUID,
			entityType: 'lesson',
			libraryUID: null,
		}
	},

	saveExpirationDate(sessionUid, newExpireTime, currentExpireTime) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE,
			sessionUid,
			newExpireTime,
			currentExpireTime,
		}
	},

	saveExpirationDateSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE_SUCCESS,
		}
	},

	saveExpirationDateFailed(sessionUid, currentExpireTime) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE_FAILED,
			sessionUid,
			currentExpireTime,
		}
	},

	updateSearch(query, orderField) {
		return {
			type: actionTypes.MY_LIBRARY_SEARCH_LESSONS,
			query,
			orderField,
		}
	},

	closeNoLessonsLti() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_NO_LESSONS_LTI_CONFIRM,
		}
	},

	closeLaunchSessionTeams() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_LAUNCH_SESSION_TEAMS,
		}
	},

	folderSelected(folderUID, folderName, orderField) {
		return {
			type: actionTypes.MY_LIBRARY_FOLDER_SELECTED,
			folderUID,
			folderName,
			orderField,
		}
	},

	exploreStoreFromLibrary() {
		return {
			type: actionTypes.MY_LIBRARY_EXPLORE_STORE,
		}
	},

	overlayOnboardingCreateLessonConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CONFIRM,
		}
	},

	overlayOnboardingCreateLessonInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_INITIALIZE,
		}
	},

	overlayOnboardingCreateLessonDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_DISMISS,
		}
	},

	overlayOnboardingCreateLessonClose() {
		return {
			type: actionTypes.MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CLOSE,
		}
	},

	overlaySubsInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_SUBS_OVERLAY_INITIALIZE,
		}
	},

	overlaySubsOnLearnMore(hasVisitedSubplans) {
		return {
			type: actionTypes.MY_LIBRARY_SUBS_OVERLAY_LEARN_MORE,
			hasVisitedSubplans,
		}
	},

	overlaySubsDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_SUBS_OVERLAY_DISMISS,
		}
	},

	overlaySubsClosed() {
		return {
			type: actionTypes.MY_LIBRARY_SUBS_OVERLAY_CLOSED,
		}
	},

	closePlatinumDowngradeAccount() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_PLATINUM_DOWNGRADE_ACCOUNT,
		}
	},

	closeAyceDowngradeAccount() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_AYCE_DOWNGRADE_ACCOUNT,
		}
	},

	closeFeatureDowngradeAccount() {
		return {
			type: actionTypes.MY_LIBRARY_CLOSE_FEATURE_DOWNGRADE_ACCOUNT,
		}
	},

	closeFeatureRedeemFailConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_FEATURE_REDEEM_FAIL_CONFIRM,
		}
	},

	overlaySchoolUserOnboardingInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_INITIALIZE,
		}
	},

	overlaySchoolUserOnboardingConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CONFIRM,
		}
	},

	overlaySchoolUserOnboardingDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_DISMISS,
		}
	},

	overlaySchoolUserOnboardingClose() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CLOSE,
		}
	},

	paywallOnButtonUpgradeNow() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_UPGRADE_NOW,
		}
	},

	paywallDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_DISMISS,
		}
	},

	upgradePaywallExpired() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_UPGRADE,
		}
	},

	closePaywallExpired() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_EXPIRED_CLOSE,
		}
	},

	upgradeReminderPaywall() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_REMINDER_UPGRADE,
		}
	},

	closeReminderPaywall() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_REMINDER_CLOSE,
		}
	},

	overlaySchoolTrialOnboardingConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM,
		}
	},

	overlaySchoolTrialOnboardingConfirmSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM_SUCCESS,
		}
	},

	overlaySchoolTrialOnboardingDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_DISMISS,
		}
	},

	overlaySchoolTrialOnboardingInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_INITIALIZE,
		}
	},

	overlaySchoolTrialOnboardingClose() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CLOSE,
		}
	},

	schoolFreeTrialOnboardingOverlayFailed(error) {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_ONBOARDING_OVERLAY_FAILED,
			error,
		}
	},

	schoolFreeTrialUserOnboardingOverlayConfirmSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_USER_ONBOARDING_OVERLAY_CONFIRM_SUCCESS,
		}
	},

	closeSchoolJoinConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_JOIN_CONFIRM_CLOSE,
		}
	},

	schoolInviteConfirmNo() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NO,
		}
	},

	schoolInviteConfirmYes() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES,
		}
	},

	schoolInviteConfirmYesSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES_SUCCESS,
		}
	},

	closeSchoolInviteConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_CLOSE,
		}
	},

	closeSchoolInviteNoSlotsConfirm() {
		return {
			type: actionTypes.MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NOSLOTS_CLOSE,
		}
	},

	shareFolder(entityUID, userId) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_FOLDER,
			entityUID,
			userId,
		}
	},

	shareFolderDataLoaded(payload, entityUID) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_FOLDER_DATA_LOADED,
			payload,
			entityUID,
			entityType: 'folder',
		}
	},

	shareFolderDataFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_SHARE_FOLDER_DATA_FAILED,
			serverError,
		}
	},

	gradesSubjectsInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_GRADES_SUBJECTS_INITIALIZE,
		}
	},

	gradesSubjectsSubmit(values, resolve, reject) {
		return {
			type: actionTypes.MY_LIBRARY_GRADES_SUBJECTS_SUBMIT,
			...values,
			resolve,
			reject,
		}
	},

	gradesSubjectsDismiss() {
		return {
			type: actionTypes.MY_LIBRARY_GRADES_SUBJECTS_DISMISS,
		}
	},

	firstLessonClosed() {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_CLOSED,
		}
	},

	firstLessonFilePicked(file) {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_FILE_PICKED,
			file,
		}
	},

	firstLessonFilePickedError(message) {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR,
			message,
		}
	},

	firstLessonFileUploadedError(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_FILE_UPLOADED_ERROR,
			serverError,
		}
	},

	firstLessonAnimationLoadingCompleted() {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_ANIMATION_LOADING_COMPLETED,
		}
	},

	firstLessonCompleted() {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_COMPLETED,
		}
	},

	firstLessonPresentationPublished(payload) {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_PRESENTATION_PUBLISHED,
			payload,
		}
	},

	firstLessonInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_FIRST_LESSON_INITIALIZE,
		}
	},

	moveLesson(folderUID, lessonUID, sourceName, targetName, presentationsCount) {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_LESSON,
			folderUID,
			lessonUID,
			sourceName,
			targetName,
			presentationsCount,
		}
	},

	moveLessonSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_LESSON_SUCCESS,
			method: 'Drag & Drop',
		}
	},

	moveLessonFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_LESSON_FAILED,
			serverError,
		}
	},

	moveFolder(folderID, sourceName, targetFolderID, targetName) {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_FOLDER,
			folderID,
			sourceName,
			targetFolderID,
			targetName,
		}
	},

	moveFolderSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_FOLDER_SUCCESS,
		}
	},

	moveFolderFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_MOVE_FOLDER_FAILED,
			serverError,
		}
	},

	timeToClimbExplore() {
		return {
			type: actionTypes.MY_LIBRARY_TIME_TO_CLIMB_EXPLORE,
		}
	},

	timeToClimbCancelled() {
		return {
			type: actionTypes.MY_LIBRARY_TIME_TO_CLIMB_CANCELLED,
		}
	},

	timeToClimbSuccess(timeToClimbAuthor) {
		return {
			type: actionTypes.MY_LIBRARY_TIME_TO_CLIMB_SUCCESS,
			timeToClimbAuthor,
		}
	},

	myLibrarySessionLtiSavedSuccess(payload, presentationUid, teams) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED_SUCCESS,
			payload,
			presentationUid,
			teams,
		}
	},

	myLibrarySessionLtiSavedError() {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED_ERROR,
		}
	},

	launchHomeworkInitialize() {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_INITIALIZE,
		}
	},

	launchHomeworkUnmount() {
		return {
			type: actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_UNMOUNT,
		}
	},

	flocabularyAnnouncementContinue() {
		return {
			type: actionTypes.MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED,
		}
	},

	flocabularyAnnouncementContinueFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED_FAILED,
			serverError,
		}
	},

	sessionShared(method, entityUID, sharedFrom) {
		return {
			type: actionTypes.MY_LIBRARY_SESSION_SHARED,
			method,
			entityUID,
			sharedFrom,
		}
	},

	immersiveReaderConfirmed() {
		return {
			type: actionTypes.MY_LIBRARY_IMMERSIVE_READER_CONFIRMED,
		}
	},

	immersiveReaderCancelled() {
		return {
			type: actionTypes.MY_LIBRARY_IMMERSIVE_READER_CANCELLED,
		}
	},

	immersiveReaderSuccess(redirectUrl) {
		return {
			type: actionTypes.MY_LIBRARY_IMMERSIVE_READER_SUCCESS,
			redirectUrl,
		}
	},

	launchFrontOfTheClassroomSessionFetched(payload) {
		return {
			type: actionTypes.MY_LIBRARY_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED,
			payload,
		}
	},

	launchFrontOfTheClassroomSessionFailed(serverError) {
		return {
			type: actionTypes.MY_LIBRARY_FRONT_OF_THE_CLASSROOM_SESSION_FAILED,
			serverError,
		}
	},

	createInteractiveVideo() {
		return {
			type: actionTypes.MY_LIBRARY_CREATE_INTERACTIVE_VIDEO,
		}
	},

	initializeVideoPreview(presentation_uid) {
		return {
			type: actionTypes.MY_LIBRARY_INITIALIZE_VIDEO_PREVIEW,
			presentation_uid,
		}
	},

	toggleRequiredSubmissions(sessionUid, value) {
		return {
			type: actionTypes.MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS,
			sessionUid,
			value,
		}
	},

	saveSessionSubmissionSuccess() {
		return {
			type: actionTypes.MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_SUCCESS,
		}
	},

	saveSessionSubmissionFailed(error, sessionUid, value) {
		return {
			type: actionTypes.MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_FAILED,
			error,
			sessionUid,
			value,
		}
	},

	closeLessonLaunchFailedMessage() {
		return {
			type: actionTypes.MY_LIBRARY_LESSON_LAUNCH_FAILED_CONFIRM_CLOSE,
		}
	},

	upgradeSelected(upgradeSource) {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_UPGRADE_SELECTED,
			upgradeSource,
		}
	},

	closeConfirmSelected() {
		return {
			type: actionTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_CLOSE_SELECTED,
		}
	},

	downloadAndLaunchStarted() {
		return {
			type: actionTypes.MY_LIBRARY_DOWNLOAD_AND_LAUNCH_STARTED,
		}
	},

	downloadFinishedAndLaunchStarted() {
		return {
			type: actionTypes.MY_LIBRARY_DOWNLOAD_FINISHED_AND_LAUNCH_STARTED,
		}
	},

	addLessonToPrivateLibraryModalCloseSelected() {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_CLOSE_SELECTED,
		}
	},
	addLessonToPrivateLibraryModalAddSelected(folderId, lesson, library_type) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_ADD_SELECTED,
			folderId,
			lesson,
			library_type,
		}
	},
	addLessonToPrivateLibraryModalFolderIdUpdated(folderId, lesson, libraryType) {
		return {
			type: actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_FOLDER_ID_UPDATED,
			folderId,
			lesson,
			libraryType,
		}
	},
	teachLesson(entity) {
		return {
			type: actionTypes.MY_LIBRARY_TEACH_LESSON_SELECTED,
			entity,
		}
	},
	teachLessonModalCloseSelected() {
		return {
			type: actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_CLOSE_SELECTED,
		}
	},
	lessonSettingsSelected() {
		return {
			type: actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_SETTINGS_SELECTED,
		}
	},
	getActivePincodesSuccess(payload) {
		return {
			type: actionTypes.MY_LIBRARY_GET_ACTIVE_PINCODES_SUCCESS,
			payload,
		}
	},
	getActivePincodesFailed(error) {
		return {
			type: actionTypes.MY_LIBRARY_GET_ACTIVE_PINCODES_FAILED,
			error,
		}
	},
	liveActiveCodesSelected(presentationUid, hasMultiplePins, hasZoom = false) {
		return {
			type: actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_LIVE_ACTIVE_CODES_SELECTED,
			presentationUid,
			hasMultiplePins,
			hasZoom,
		}
	},
	creationMenuCreateLesson() {
		return {
			type: actionTypes.MY_LIBRARY_CREATION_MENU_CREATE_LESSON_SELECTED,
		}
	},
}

export default myLibraryActions
